import b from 'b_';
import { Expand } from 'education-icons';
import { Button, SimpleCallback } from 'platform-components';
import React from 'react';

import { PROBLEM_DISPLAY_STATUS } from 'common.components/student-lesson-stat/typings';

import { useIsDesktop } from '../utils';

import './lesson-content__item-wrapper.scss';

interface Props {
    children: React.ReactNode;
    fullScreen?: boolean;
    status: PROBLEM_DISPLAY_STATUS;
    onExpand: SimpleCallback;
}

const LessonContentItemWrapper = ({ children, fullScreen, status, onExpand }: Props) => {
    const isDesktop = useIsDesktop();
    return (
        <div className={b('lesson-content', 'item-wrapper', { status, 'full-screen': fullScreen })}>
            <div className={b('lesson-content', 'item')}>{children}</div>
            {isDesktop && (
                <Button
                    className="lesson-content__expand-button"
                    icon={<Expand />}
                    onClick={onExpand}
                    rounded
                    size={Button.SIZE.M}
                    view={Button.VIEW.RAISED}
                />
            )}
        </div>
    );
};

export default LessonContentItemWrapper;
